// Copyright (c) 2016 Deere & Company

import PinCrossReference from '../../../reports/pin-cross-reference/state-connector';

export default {
    component: PinCrossReference,
    name: 'PIN_CROSS_REFERENCE',
    path: 'pin-cross-reference'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/pin-cross-reference.js